
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsStyleDialog extends Serenity.EntityDialog<CsStyleRow, any> {
        protected getFormKey() { return CsStyleForm.formKey; }
        protected getIdProperty() { return CsStyleRow.idProperty; }
        protected getLocalTextPrefix() { return CsStyleRow.localTextPrefix; }
        protected getNameProperty() { return CsStyleRow.nameProperty; }
        protected getService() { return CsStyleService.baseUrl; }
        protected getDeletePermission() { return CsStyleRow.deletePermission; }
        protected getInsertPermission() { return CsStyleRow.insertPermission; }
        protected getUpdatePermission() { return CsStyleRow.updatePermission; }

        protected form = new CsStyleForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var  Styleid = Q.tryFirst(CsSkuRow.getLookup().items, x => x.StyleId == this.entity.StyleId);
            if(Styleid != null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.StyleId == this.entity.StyleId);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }
        
    }
}